import { useBreakpointValue } from '@genial/utils';
import React from 'react';

import { SecondCopyListLoadingDesktop } from './Desktop';
import { SecondCopyListLoadingMobile } from './Mobile';
import { SecondCopyListLoadingTablet } from './Tablet';

export const SecondCopyListLoading: React.FC = () => {
  return useBreakpointValue({
    base: <SecondCopyListLoadingMobile />,
    sm: <SecondCopyListLoadingTablet />,
    lg: <SecondCopyListLoadingDesktop />,
  });
};
